import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatBotRepliesService {


  private BaseUrl = environment.serverAPI8;
  url = environment.serverAPI8 + "/api/chat/bot-replies";

  constructor(private http: HttpClient) { }

  getBotReplies(page: number, size: number) {
    const params = new HttpParams()
      .set('page', page)
      .set('size', size);

    return this.http.get<any>(`${this.BaseUrl}/api/bot-replies/list-data`);
  }

  updateProcess(payload: unknown): Observable<any> {
    return this.http.post<any>(`${this.url}/update-process`, payload);
  }
    addProcess(payload: unknown): Observable<any> {
    return this.http.post<any>(`${this.url}/add-process`, payload);
  }



  //for search botReplies
  // In BotFlowsService class

  searchBotReplies(query: string, page: number, size: number, sort: string): Observable<Response[]> {


    const requestBody = {
     "searchQuery": query != null ? query.split("'").join('') : null ,
    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; // Construct query parameters


    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  getUpdateData(botReplyUid: string): Observable<any> {
    // const params = new HttpParams().set('vendorId', vendorId);

    return this.http.get<any>(`${this.url}/${botReplyUid}/get-update-data`);
  }

  deleteProcess(uid: string): Observable<any> {

    return this.http.delete<any>(`${this.url}/${uid}/delete-process`);
  }

  duplicateProcess(uid: string): Observable<any> {
    return this.http.get<any>(`${this.url}/${uid}/duplicate-process`);
  }

  isLoading = new Subject<boolean>();

  show() {
    this.isLoading.next(true);
    
  }
}
